import layout from '@/layout'

export default {
  path: '/operation',
  component: layout,
  redirect: '/operation/smsSecretManage',
  name: 'smsPlatform',
  meta: {
    title: '运营设置',
    icon: 'setting-config'
  },
  children: [
    {
      path: '/operation/smsSecretManage',
      component: () => import('@/views/operation/smsSecretManage/sms-secret/index.vue'),
      meta: { title: '短信平台', icon: 'messages' }
    },
    {
      path: '/operation/smsSecretManage/moduleManage/:appId',
      name: 'smsModuleManage',
      component: () => import('@/views/operation/smsSecretManage/sms-module/index.vue'),
      meta: { title: '短信模板管理' }
    },
    {
      path: '/operation/smsSecretManage/moduleDetail/:id',
      name: 'smsModuleInfo',
      component: () =>
        import('@/views/operation/smsSecretManage/sms-module-info/index.vue'),
      meta: { title: '短信模板详情' }
    },
    {
      path: '/operation/smsSecretManage/signManage/:appId',
      name: 'smsSignManage',
      component: () => import('@/views/operation/smsSecretManage/sms-sign/index.vue'),
      meta: { title: '短信签名管理' }
    },
    {
      path: '/operation/smsSecretManage/signRecordManage/:appId',
      name: 'smsRecordManage',
      component: () => import('@/views/operation/smsSecretManage/sms-records/index.vue'),
      meta: { title: '短信发送记录管理' }
    },
    {
      path: '/operation/smsSecretManage/signRecordDetail/:id',
      name: 'smsRecordInfo',
      component: () =>
        import('@/views/operation/smsSecretManage/sms-record-info/index.vue'),
      meta: { title: '短信发送记录详情' }
    }
  ]
}
